import React from "react";
import LogoImage from "../../assets/Logo.png";
import { FaPhone, FaEnvelope, FaWhatsapp, FaLinkedin } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Copy email to clipboard
  const handleEmailCopy = (email) => {
    navigator.clipboard.writeText(email);
    alert("Email copied to clipboard!");
  };

  // Reusable contact link component
  const ContactLink = ({ href, icon: Icon, text, onClick }) => (
    <div className="contact-item">
      {onClick ? (
        <div className="contact-link" onClick={onClick} style={{ cursor: "pointer" }}>
          <Icon className="contact-icon" />
          <p>{text}</p>
        </div>
      ) : (
        <a
          href={href}
          className="contact-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon className="contact-icon" />
          <p>{text}</p>
        </a>
      )}
    </div>
  );

  // Contact info data
  const contacts = [
    { href: "tel:+37443099070", icon: FaPhone, text: "+37443099070" },
    {
      href: "#",
      icon: FaEnvelope,
      text: "cto@elyx.work",
      onClick: () => handleEmailCopy("cto@elyx.work"),
    },
    { href: "https://wa.me/37443099070", icon: FaWhatsapp, text: "WhatsApp" },
    {
      href: "https://www.linkedin.com/company/codered-digital/?viewAsMember=true",
      icon: FaLinkedin,
      text: "LinkedIn",
    },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section */}
        <div className="footer-left">
          <div className="logo-container">
            <img src={LogoImage} alt="Company Logo" className="footer-logo" />
          </div>
          <div className="contact-info">
            {contacts.map((contact, index) => (
              <ContactLink
                key={index}
                href={contact.href}
                icon={contact.icon}
                text={contact.text}
                onClick={contact.onClick}
              />
            ))}
          </div>
        </div>

        {/* Map Section */}
        <div className="map">
          <iframe
            title="Google Map Location"
            className="google-map"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12144.08449497968!2d44.500860!3d40.202264!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4041e21c08f1e4c1%3A0x0!2zNDDCsDEyJzA4LjEiTiA0NMKwMzAnMDMuMSJF!5e0!3m2!1sen!2s!4v1695678901234!5m2!1sen!2s"
            style={{
              width: "100%",
              height: "250px",
              border: "0",
              borderRadius: "25px",
            }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
          <p className="copyright-text">
            &copy; {currentYear} Company. All rights reserved.
          </p>
        </div>
      </div>

      {/* Social Media Icons */}
      <div className="social-icons">
        <a href="https://t.me/CodeRedHub" target="_blank" rel="noopener noreferrer">
          <img src="/icons/telegram.png" alt="Telegram" />
        </a>
        <a href="https://www.facebook.com/profile.php?id=61555155434996&sk=photos" target="_blank" rel="noopener noreferrer">
          <img src="/icons/facebook.png" alt="Facebook" />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <img src="/icons/twitter.png" alt="Twitter" />
        </a>
        <a href="https://www.tiktok.com/@code__red__hub" target="_blank" rel="noopener noreferrer">
          <img src="/icons/tiktok.png" alt="TikTok" />
        </a>
        <a href="https://www.linkedin.com/company/codered-digital/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
          <img src="/icons/linkedin.png" alt="LinkedIn" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
